import { ApolloClient, InMemoryCache } from "@apollo/client";
import { persistCache, SessionStorageWrapper } from "apollo3-cache-persist";

const cache = new InMemoryCache();

export const handleCachePersistError = (error) => {
  console.warn('Apollo cache persistence error:', error);
  if (error.message?.includes('quota')) {
    sessionStorage.removeItem('apollo-cache-persist');
    console.log('Cleared Apollo cache due to quota exceeded');
  }
};

export const waitOnCache = persistCache({
  cache,
  storage: new SessionStorageWrapper(globalThis.sessionStorage),
  maxSize: 1048576, // 1MB limit
  debounce: 1000, // Wait 1 second before persisting
}).catch(handleCachePersistError);

export const apolloClient = new ApolloClient({
  uri: process.env.REACT_APP_GRAPHQL_SERVER_URL,
  credentials: "include",
  cache: cache,
  connectToDevTools: true,
  headers: {
    Authorization: localStorage.getItem("jwtToken")
  },
});
